<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
  /* eslint-disable */

  import store from './store'
  export default {
    created: function () {
     axios.interceptors.response.use((response) => {
      return response
      }, (error) => {
        if (error.response.status == 401) {
            localStorage.removeItem('token')
            localStorage.removeItem('expiration')
            store.commit('logOutUser')
            this.$router.push({ name: 'Login-Layout' })
        }
        return Promise.reject(error);
     })
    },
  }
</script>
<style lang="scss">
/* .vue-notifyjs.notifications{ */
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  /* } */
</style>



// WEBPACK FOOTER //
// src/App.vue